// Enhanced analytics with Core Web Vitals tracking
export const enhancedAnalytics = {
  // Track Core Web Vitals
  trackWebVitals: () => {
    if (typeof window !== 'undefined') {
      import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB }) => {
        onCLS(metric => {
          if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
            window.dataLayer.push({
              event: 'web_vitals',
              event_category: 'Performance',
              event_label: 'CLS',
              value: Math.round(metric.value * 1000),
              non_interaction: true,
            });
          }
        });

        onFCP(metric => {
          if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
            window.dataLayer.push({
              event: 'web_vitals',
              event_category: 'Performance',
              event_label: 'FCP',
              value: Math.round(metric.value),
              non_interaction: true,
            });
          }
        });

        onLCP(metric => {
          if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
            window.dataLayer.push({
              event: 'web_vitals',
              event_category: 'Performance',
              event_label: 'LCP',
              value: Math.round(metric.value),
              non_interaction: true,
            });
          }
        });

        onTTFB(metric => {
          if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
            window.dataLayer.push({
              event: 'web_vitals',
              event_category: 'Performance',
              event_label: 'TTFB',
              value: Math.round(metric.value),
              non_interaction: true,
            });
          }
        });
      }).catch(() => {
        // Gracefully handle if web-vitals fails to load
      });
    }
  },

  // Track user interactions
  trackFormSubmission: (formType: string) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
      window.dataLayer.push({
        event: 'form_submit',
        event_category: 'Engagement',
        event_label: formType,
      });
    }
  },

  trackLanguageChange: (fromLang: string, toLang: string) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
      window.dataLayer.push({
        event: 'language_change',
        event_category: 'User Preference',
        custom_parameter_1: fromLang,
        custom_parameter_2: toLang,
      });
    }
  },

  trackPageEngagement: (timeOnPage: number) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com') && timeOnPage > 10000) {
      window.dataLayer.push({
        event: 'page_engagement',
        event_category: 'Engagement',
        value: Math.round(timeOnPage / 1000),
        non_interaction: true,
      });
    }
  }
};

// Initialize enhanced analytics
export const initializeEnhancedAnalytics = () => {
  if (typeof window !== 'undefined') {
    // Track Core Web Vitals
    enhancedAnalytics.trackWebVitals();
    
    // Track page engagement time
    let startTime = Date.now();
    
    const trackEngagement = () => {
      const timeOnPage = Date.now() - startTime;
      enhancedAnalytics.trackPageEngagement(timeOnPage);
    };
    
    window.addEventListener('beforeunload', trackEngagement);
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        trackEngagement();
        startTime = Date.now(); // Reset for next visibility
      }
    });
  }
};